// Format category string: replace underscores with spaces and apply title case

const normalizeCategory = (category?: string): string => {
  if (!category) return "";
  return category
    .replace(/[_-]+/g, " ")
    .replace(/([A-Z])/g, " $1")
    .split(" ")
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export default normalizeCategory;

const GENERIC_TYPES = new Set(["PhysicalVenue", "Eventish", "GeoArea", "PersonOrgBrand", "place"]);

/** Extract a meaningful category key from an entity, or undefined if generic/missing. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getEntityCategory(entity: any): string | undefined {
  const gp = entity.google_places || entity.enrichment_data?.google_places;
  const raw: string | undefined = gp?.primary_type || entity.category || entity.entity_type;
  return raw && typeof raw === "string" && !GENERIC_TYPES.has(raw) ? raw : undefined;
}
